module.exports = __webpack_public_path__ + "static/media/iphone 12 pro max banner3.2fabfcca.jpg";